import React from "react";
import { Link } from "react-router-dom";
import InputRow from "./InputRow";
import PropTypes from "prop-types";
import { emailCheck, pwdCheck } from "../constants";
import submit from "../submit.gif";
import logo from "../logo.png";
import "../Main.css";

export default class CardPayments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      pwd: "",
      error: "",
      errorColor: "red",
      processing: false,
      resetProcessing: false,
      // isActive:false
    };
    this.handleLogin = this.handleLogin.bind(this);
    //this.resetPassword = this.resetPassword.bind(this)
  }

  async handleLogin() {
    this.setState({ processing: true });
    const { email, pwd } = this.state;
    sessionStorage.clear();
    if (email && pwd) {
      fetch(`${process.env.REACT_APP_API_URL}/api/login/paymentCard`, {
        method: "POST",
        body: JSON.stringify({
          Email: email,
          GovID: pwd,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.StatusCode === 200) {
            this.setState({ processing: false });
            // sessionStorage.setItem("token", res.Data.Token);
            // sessionStorage.setItem("govID", res.Data.IncompleteApplicationId);
            // sessionStorage.setItem("email", email);
            window.location.href = res.Token;
          } else {
            this.setState({
              error: res.Msg,
              processing: false,
              errorColor: "red",
              pwd: "",
            });
          }
        })
        .catch((err) => {
          this.setState({ error: "Network Error", processing: false, pwd: "" });
          console.log(err);
        });
    }
  }

  render() {
    const {
      errorColor,
      email,
      pwd,
      error,
      processing,
      resetProcessing,
      isActive,
    } = this.state;
    return (
      <div id="mainContainer">
        <div id="designBorder"></div>
        <img
          src={logo}
          className="center main-logo"
          style={{ paddingTop: 20 }}
        ></img>
        <div id="main-page">
          <p
            style={{
              color: errorColor,
            }}
          >
            {error}
          </p>
          <div>
            <div>
              <InputRow
                rowName="Email Address"
                name="email"
                value={email}
                onChange={(val) => this.setState({ email: val })}
                required="*"
              />
              <InputRow
                rowName="Government ID"
                name="password"
                value={pwd}
                onChange={(val) => this.setState({ pwd: val })}
                required="*"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    this.handleLogin();
                  }
                }}
              />
            </div>
          </div>
          <button
            className="save"
            onClick={this.handleLogin}
            disabled={processing}
          >
            {processing ? (
              <img
                src={submit}
                alt="Loading..."
                style={{ width: 18, height: 18 }}
              />
            ) : (
              "Make Payment"
            )}
          </button>
          {/* <button className="save" onClick={this.resetPassword} disabled={resetProcessing}>
                {resetProcessing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }}/> : 'Reset Password'}
              </button> */}
          <p>
            If you don&apos;t have an account,{" "}
            <cite>
              <Link className="links" to="/signup">
                Create
              </Link>
            </cite>
          </p>
          <p>
            <b>Important:</b> Please note that this password will be used to
            access your application
          </p>
        </div>
      </div>
    );
  }
}
